// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PStrikethroughOutlinedSvg from "@fishx/icons-svg/es/asn/PStrikethroughOutlined";
import FishxIcon from '../components/FishxIcon';

var PStrikethroughOutlined = function PStrikethroughOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PStrikethroughOutlinedSvg
  }));
};

PStrikethroughOutlined.displayName = 'PStrikethroughOutlined';
export default React.forwardRef(PStrikethroughOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PStrikethroughOutlined.js
// module id = 3666
// module chunks = 0